var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "laskutus-asiakas-selaa" },
    [
      _c(
        "v-navigation-drawer",
        {
          ref: "offCanvas",
          attrs: { width: "450", app: "", right: "", temporary: "" },
          model: {
            value: _vm.showOffCanvas,
            callback: function ($$v) {
              _vm.showOffCanvas = $$v
            },
            expression: "showOffCanvas",
          },
        },
        [
          _vm.loadingOffCanvas
            ? _c("Spinner")
            : _c("OffCanvasAsiakas", {
                on: {
                  "close-button-click": _vm.setShowOffCanvas,
                  messageSubmit: _vm.refresh,
                  "msg-mark-as-unread": _vm.refresh,
                  "msg-mark-as-read": _vm.refresh,
                },
                model: {
                  value: _vm.selectedItem.item,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedItem, "item", $$v)
                  },
                  expression: "selectedItem.item",
                },
              }),
        ],
        1
      ),
      _c("ViewSelaaTopBarBase", {
        ref: "topBar",
        attrs: {
          "pikahaun-placeholder-teksti": "Hae (asiakasnumero, ID, tunnus)",
          "vuex-module-name": _vm.vuexModuleName,
        },
        on: {
          "open-search-panel": _vm.openSearchPanel,
          "close-search-panel": _vm.closeSearchPanel,
        },
      }),
      _c("ViewSelaaTabs", {
        attrs: { "vuex-module-name": _vm.vuexModuleName },
      }),
      _c("TransitionSlidePanel", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.searchPanelOpen,
                expression: "searchPanelOpen",
              },
            ],
            staticClass: "pa-1 primary darken-1 shadow--inset",
          },
          [
            _c("InfoValittuValilehti", {
              attrs: { "current-tab": _vm.currentTab },
            }),
            _c("FormSearchVastapuoli", {
              model: {
                value: _vm.searchTerms,
                callback: function ($$v) {
                  _vm.searchTerms = $$v
                },
                expression: "searchTerms",
              },
            }),
          ],
          1
        ),
      ]),
      _c("ViewSelaaToolbar", {
        attrs: {
          "vuex-module-name": _vm.vuexModuleName,
          "item-partitiivi": "asiakasta",
          "lataa-csv-btn-config": {
            csvData: _vm.csvData,
            csvLabels: _vm.csvLabels,
            csvTitle: _vm.csvTitle,
          },
          "uusi-btn-config": {
            click: _vm.avaaDialogAsiakas,
            itemName: "asiakas",
          },
          "tuo-aineistoa-btn-config": {
            click: function () {
              _vm.tuoCSVDialogAuki = true
            },
            text: "Tuo asiakkaita",
          },
        },
      }),
      _c("v-data-table", {
        staticClass: "v-data-table--striped",
        attrs: {
          headers: _vm.tableHeaders,
          items: _vm.items,
          "hide-default-footer": _vm.items.length < 10,
          "footer-props": {
            itemsPerPageOptions: [10, 25, 50, 100],
          },
          "multi-sort": true,
          "server-items-length": _vm.itemsTotal,
          options: _vm.pagination,
          loading: _vm.loading,
          "loading-text": "",
          "no-data-text": "",
          dense: _vm.tiivisNakyma,
        },
        on: {
          "update:options": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "progress",
            fn: function () {
              return [
                _c("v-progress-linear", {
                  attrs: { color: "primary", indeterminate: "" },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "item",
            fn: function (ref) {
              var item = ref.item
              return [
                _c(
                  "TableRow",
                  {
                    attrs: {
                      clickable: true,
                      data: item,
                      fade: _vm.loading,
                      "custom-contextmenu": true,
                    },
                    on: {
                      contextmenu: function ($event) {
                        $event.preventDefault()
                        return _vm.avaaMenuContext($event, item)
                      },
                      click: function ($event) {
                        _vm.eiOikeuttaAvataAsiakasta(item)
                          ? function () {}
                          : _vm.setSelectedItem({ item: item })
                      },
                    },
                  },
                  [
                    _c(
                      "td",
                      { staticClass: "text-no-wrap" },
                      [
                        _c("v-tooltip", {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  return [
                                    item.ikoni_ja_vari
                                      ? _c("StatusIcon", {
                                          attrs: {
                                            icon: item.ikoni_ja_vari.ikoni,
                                            size: _vm.tiivisNakyma
                                              ? "small"
                                              : "medium",
                                            "hover-icon":
                                              _vm.maaritaHoverIcon(item),
                                            "bg-color": item.ikoni_ja_vari.vari,
                                            "event-listener": on,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.maaritaClickHandler(
                                                item
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "default",
                                fn: function () {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.maaritaStatusIconTooltipTeksti(
                                            item
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm.eiOikeuttaAvataAsiakasta(item) &&
                    !_vm.trafiLupaNaytaVainNimi
                      ? _c("td", { staticClass: "max-width font-italic" }, [
                          _vm._v(" Ei voida näyttää tietosuojasyistä "),
                        ])
                      : _c("td", { staticClass: "max-width" }, [
                          _vm._v(" " + _vm._s(item.nimi) + " "),
                        ]),
                    _c("td", { staticClass: "text-no-wrap" }, [
                      _vm._v(" " + _vm._s(item.nro) + " "),
                    ]),
                    _c("td", { staticClass: "text-no-wrap" }, [
                      _vm._v(" " + _vm._s(item.id) + " "),
                    ]),
                    _vm.eiOikeuttaAvataAsiakasta(item)
                      ? _c("td", { staticClass: "text-no-wrap font-italic" }, [
                          _vm._v(" Ei voida näyttää tietosuojasyistä "),
                        ])
                      : _c("td", { staticClass: "text-no-wrap" }, [
                          _vm._v(" " + _vm._s(item.tunnus) + " "),
                        ]),
                    _c("td", { staticClass: "text-no-wrap" }, [
                      _vm._v(" " + _vm._s(item.tyyppi) + " "),
                    ]),
                    _c("td", { staticClass: "text-no-wrap" }, [
                      _vm._v(
                        " " +
                          _vm._s(item.paamies.nimi) +
                          " (" +
                          _vm._s(item.paamies.id) +
                          ") "
                      ),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm.tyhjaTaulukko
        ? _c("TyhjaTaulukkoOtsikko", {
            attrs: { otsikko: _vm.$t("youHaveNoCustomers") },
          })
        : _vm._e(),
      _vm.tyhjaTaulukko
        ? _c("ToolbarTyhjaTaulukko", {
            attrs: {
              ikoni: "library_add",
              taustavari: "success",
              teksti: _vm.$t("newCustomer"),
              infoteksti: _vm.$t("noCustomerAddInfo"),
              naytaAina: true,
            },
            on: { click: _vm.avaaDialogAsiakas },
          })
        : _vm._e(),
      _vm.pagesTotal > 1
        ? _c(
            "v-toolbar",
            { staticClass: "py-6 transparent", attrs: { flat: "" } },
            [
              _c("v-spacer"),
              _c("Pagination", {
                attrs: { length: _vm.pagesTotal, disabled: _vm.loading },
                model: {
                  value: _vm.pagination.page,
                  callback: function ($$v) {
                    _vm.$set(_vm.pagination, "page", $$v)
                  },
                  expression: "pagination.page",
                },
              }),
              _c("v-spacer"),
            ],
            1
          )
        : _vm._e(),
      _c(
        "CardDialog",
        {
          attrs: {
            title: "Uusi asiakas",
            "dialog-auki": _vm.asiakasDialogAuki,
            "title-class": "px-12 py-6",
            "content-class": "px-12 py-4",
            width: "1024",
          },
          on: {
            close: function ($event) {
              _vm.asiakasDialogAuki = false
            },
          },
        },
        [
          _c("FormAsiakas", {
            attrs: {
              "kenttien-valinnat": _vm.kenttienValinnat,
              "on-auki": _vm.asiakasDialogAuki,
            },
            on: {
              close: function ($event) {
                _vm.asiakasDialogAuki = false
              },
              asiakasTallennettu: _vm.siirryAsiakasnakymaan,
            },
          }),
          _c("v-divider", { staticClass: "mt-8 mb-8" }),
        ],
        1
      ),
      _c("MenuContext", {
        attrs: {
          "onko-nakyvissa": _vm.menuContextNakyvissa,
          "position-x": _vm.menuContextX,
          "position-y": _vm.menuContextY,
          vaihtoehdot: _vm.menuContextVaihtoehdot,
        },
        on: {
          avaaValilehteen: _vm.avaaUudessaValilehdessa,
          "update:return-value": _vm.suljeMenuContext,
        },
      }),
      _c(
        "CardDialog",
        {
          attrs: {
            title: "Tuo CSV-tiedostosta",
            "dialog-auki": _vm.tuoCSVDialogAuki,
            "title-class": "px-12 py-6",
            "content-class": "px-12 py-4",
            width: "600",
            "tooltip-info-teksti": _vm.AsiakasCSVInfo,
          },
          on: {
            close: function ($event) {
              _vm.tuoCSVDialogAuki = false
            },
          },
        },
        [
          _c("FormAsiakasCSV", {
            attrs: { "on-auki": _vm.tuoCSVDialogAuki },
            on: {
              close: function ($event) {
                _vm.tuoCSVDialogAuki = false
              },
              "asiakkaita-tallennettu": function ($event) {
                return _vm.resetoiJaAsetaSearchQuery("")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }